export default ({url, btn, popup, reader}) => {
  let hasSaved = false;

  const onClick = () => {
    if (hasSaved) {
      popup.close();
      reader.open();
      return false;
    }

    popup.save(url);
  };

  const onSaveSuccess = () => {
    hasSaved = true;
    popup.saved();
    btn.increment();
  };

  // Public
  return {
    attach() {
      btn.onClick(onClick);
    },
  }
}
